import * as core from '../../../../../../../core'

import { query } from './save-monitoring-activity.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.save-activity',
    description: 'Save Monitoring Activity',
    name: 'Save Monitoring Activity',
    query,
  },
  type: core.quiver.Resource.Type.MosaicAction,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicAction>
